import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Component from "./component";
import { updateSSRStatus, getSeoContent } from "../rto-info/actions";

const mapStateToProps = ({
    rtoInfo: {
        cms,
        jsonContent
    }
}) => ({
    cms,
    jsonContent
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateSSRStatusConnect: updateSSRStatus,
    getSeoContentConnect: getSeoContent
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Component));
